import $ from 'jquery';

const url = new URL(window.location.href);

const params = new URLSearchParams(url.search);
const targetParam = 'utm_medium';

if (params.has(targetParam)) {
    const paramValue = params.get(targetParam);
   
    const numberCampaignsOptions = numbersCampaign.data;
    const matchingCampaign = numberCampaignsOptions.find(item => item.campaign === paramValue);

    if(matchingCampaign){
        $('.js-header-dynamic-number').text(matchingCampaign.number)
        $('.js-header-dynamic-number-icon').addClass('hidden')
        $('.js-header-phone').attr('href', 'tel:' + matchingCampaign.number);

        // Update the script dynamically
        const script = document.getElementById('msq_pixel_id');
        if (script) {
            const currentSrc = new URL(script.src);
            currentSrc.searchParams.set('__maskyoo', matchingCampaign.number);
            script.src = currentSrc.toString();
        }
    }
}

$('.js-header-phone').removeClass('is-transparent');

